<template>
  <div class="container">
    <div class="top">
      <!-- <div class="flex">
        <van-icon name="like-o" @click="urlchange('/myfav')" />
        <van-icon name="envelop-o" :dot="badge" @click="urlchange('/mail')" />
      </div> -->
    </div>
    <div class="center" style="margin-top: -50px">
      <img :src="obj.img" class="tx" alt="" @click="urlchange('/infochange')" />
      <div class="centerflex">
        <div>
          <div class="flexdiv">
            <p class="username" @click="urlchange('/infochange')">
              {{ obj.name }}
            </p>
          </div>
        </div>
        <van-icon
          style="margin-left: auto"
          name="envelop-o"
          :dot="badge"
          @click="urlchange('/mail')"
        />
        <van-icon name="star-o" @click="urlchange('/myfav')" />
      </div>
      <p class="font-14 font-333" style="margin-top: 20px; padding: 6px 0">
        组织：{{ org }}
      </p>
      <p class="font-14 font-333">级别：{{ obj.level_str }}</p>
      <!-- <div
        class="flex"
        style="font-weight: bold; margin-top: 20px; text-align: left"
      >
        <div @click="urlchange('/myjf')">
          <p>可用积分：{{ obj.score }}</p>
          <p>总积分：{{ totaljf }}</p>
        </div>
        <p @click="urlchange('/hourslog')">服务时长：{{ obj.hours }}h</p>
      </div> -->
    </div>
    <div class="center" style="margin-top: 10px">
      <div class="flex">
        <div style="width: 100%" @click="urlchange('/myjf')">
          <p class="font-weight">{{ obj.score }}</p>
          <p class="font-12">可用积分</p>
        </div>
        <div style="width: 100%" @click="urlchange('/myjf')">
          <p class="font-weight">{{ totaljf }}</p>
          <p class="font-12">总积分</p>
        </div>
        <div style="width: 100%" @click="urlchange('/hourslog')">
          <p class="font-weight">{{ obj.hours }}h</p>
          <p class="font-12">服务时长</p>
        </div>
      </div>
    </div>
    <div
      style="
        padding: 12px 0;
        text-align: center;
        background: white;
        color: #1646c0;
        font-weight: bold;
        margin: 10px;
        border-radius: 10px;
      "
      @click="download()"
    >
      <p>此处下载操作手册</p>
    </div>
    <!-- 每日任务 -->
    <div class="center" style="margin: 10px">
      <div class="blockflex" style="margin-bottom: 15px">
        <div>
          <!-- <span class="color"></span> -->
          <span style="font-weight: bold" class="font-333">每日任务</span>
        </div>
        <p style="text-align: right; color: #999999" class="font-12">
          今日已领{{ todayscore }}分
        </p>
      </div>
      <div class="blockflex">
        <p class="font-333 font-14">
          登录云平台得1积分，每日最多得1积分({{ score.login.num }}/{{
            score.login.limit
          }})
        </p>
        <div
          class="bt"
          style="color: white; background: #1646c0"
          v-if="score.login.num != score.login.limit"
          @click="logjf"
        >
          领取积分
        </div>
        <div v-else class="bt" style="color: white; background: #1646c0">
          已领取
        </div>
      </div>
      <div class="blockflex">
        <p class="font-333 font-14">
          点赞、评论、发布澄风show各得1积分，每日最多得5积分({{
            score.hudong.num
          }}/{{ score.hudong.limit }})
        </p>
        <div
          class="bt"
          @click="urlchange('/cfshow')"
          v-if="score.hudong.num != score.hudong.limit"
        >
          去做任务
        </div>
        <div class="bt" v-else>已完成</div>
      </div>
      <div class="blockflex">
        <p class="font-333 font-14">
          分享至朋友圈得1积分，每日最多得2积分({{ score.share.num }}/{{
            score.share.limit
          }})
        </p>
        <div
          class="bt"
          @click="urlchange('/eventcenterdetail')"
          v-if="score.share.num != score.share.limit"
        >
          去做任务
        </div>
        <div v-else class="bt">已完成</div>
      </div>
      <div class="blockflex">
        <p class="font-333 font-14">
          参加一场活动得3积分，每日最多得6积分({{ score.task.num }}/{{
            score.task.limit
          }})
        </p>
        <div
          class="bt"
          @click="urlchange('/eventcenterdetail')"
          v-if="score.share.num != score.share.limit"
        >
          去做任务
        </div>
        <div v-else class="bt">已完成</div>
      </div>
    </div>
    <!-- 积分兑换 -->
    <div class="center">
      <div class="blockflex" style="margin-bottom: 15px">
        <div>
          <!-- <span class="color"></span> -->
          <span style="font-weight: bold" class="font-333">积分礼遇</span>
        </div>
        <p
          style="text-align: right; color: grey; font-size: 14px"
          @click="$router.push('/jfcenter')"
        >
          更多>
        </p>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-align: center;
          padding-bottom: 10px;
        "
      >
        <div
          style="width: 25%"
          v-for="(item, index) in ranknum.score_banner_list"
          :key="'jf' + index"
        >
          <img
            :src="item.cover"
            style="
              width: 32px;
              height: 32px;
              border-radius: 50%;
              display: block;
              margin: 5px auto;
            "
            alt=""
            @click="$router.push('/jfcenter')"
          />
          <p class="font-14" @click="$router.push('/jfcenter')">
            {{ item.title }}
          </p>
        </div>
      </div>
    </div>
    <!-- 排名 -->
    <div class="block">
      <table></table>
      <div class="tabs">
        <div @click="tab = 0" :class="{ active: tab == 0 }">
          <p>月度志愿之星</p>
          <div class="tabhr" v-show="tab == 0"></div>
        </div>
        <div @click="tab = 1" :class="{ active: tab == 1 }">
          <p>年度志愿之星</p>
          <div class="tabhr" v-show="tab == 1"></div>
        </div>
      </div>
      <div class="tabcontainer" v-show="tab == 0">
        <!-- <div class="rank">
          <div>
            <p>江阴市排名</p>
            <p>我的排名：{{ ranknum.my_rank_month_all }}</p>
          </div>
          <span></span>
          <div>
            <p>组织排名</p>
            <p>我的排名：{{ ranknum.my_rank_month_org }}</p>
          </div>
        </div>
        <hr /> -->
        <div class="rankmain">
          <div class="rankleft">
            <div
              class="colortop-blue"
              style="border-radius: 8px 8px 0 0"
              @click="rank('rank_m')"
            >
              <img src="static/img/center02.png" class="medal" alt="" />
              <p class="font-weight font-333">江阴市排名</p>
              <van-icon
                name="arrow"
                size="16"
                style="margin-left: auto; margin-right: 0"
              />
            </div>
            <div
              v-for="(item, index) in rank_m"
              :key="index"
              @click="rangelink(item.m_id)"
              v-show="index < 10"
            >
              <div v-if="index == 0" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/first.png"
                  alt=""
                />
              </div>
              <div v-else-if="index == 1" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/second.png"
                  alt=""
                />
              </div>
              <div v-else-if="index == 2" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/third.png"
                  alt=""
                />
              </div>
              <div v-else class="medal">
                <p>{{ index + 1 }}</p>
              </div>
              <div style="display: flex; align-items: center">
                <!-- <img :src="item.img" class="ranktx" alt="" /> -->
                <p>{{ item.name }}</p>
              </div>
              <p class="num">{{ item.hours }}h</p>
            </div>
          </div>
          <!-- <span></span> -->
          <div class="rankleft">
            <div
              class="colortop-yellow"
              style="border-radius: 8px 8px 0 0"
              @click="rank('rank_m_org')"
            >
              <img src="static/img/center01.png" class="medal" alt="" />
              <p class="font-weight font-333">组织排名</p>
              <van-icon
                name="arrow"
                size="16"
                style="margin-left: auto; margin-right: 0"
              />
            </div>
            <div
              v-for="(item, indexright) in rank_m_org"
              :key="indexright"
              @click="rangelink(item.m_id)"
              v-show="indexright < 10"
            >
              <div v-if="indexright == 0" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/first.png"
                  alt=""
                />
              </div>
              <div v-else-if="indexright == 1" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/second.png"
                  alt=""
                />
              </div>
              <div v-else-if="indexright == 2" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/third.png"
                  alt=""
                />
              </div>
              <div v-else class="medal">
                <p>{{ indexright + 1 }}</p>
              </div>
              <div style="display: flex; align-items: center">
                <!-- <img :src="item.img" class="ranktx" alt="" /> -->
                <p>{{ item.name }}</p>
              </div>
              <p class="num">{{ item.hours }}h</p>
            </div>
          </div>
        </div>
        <!-- <div class="rankbt">
          <div @click="rank('rank_m')">查看更多</div>
          <div @click="rank('rank_m_org')">查看更多</div>
        </div> -->
      </div>
      <div class="tabcontainer" v-show="tab == 1">
        <!-- <div class="rank">
          <div>
            <p>江阴市排名</p>
            <p>我的排名：{{ ranknum.my_rank_year_all }}</p>
          </div>
          <span></span>
          <div>
            <p>组织排名</p>
            <p>我的排名：{{ ranknum.my_rank_year_org }}</p>
          </div>
        </div>
        <hr /> -->
        <div class="rankmain">
          <div class="rankleft">
            <div
              class="colortop-blue"
              style="border-radius: 8px 8px 0 0"
              @click="rank('rank_y')"
            >
              <img src="static/img/center02.png" class="medal" alt="" />
              <p class="font-weight font-333">江阴市排名</p>
              <van-icon
                name="arrow"
                size="16"
                style="margin-left: auto; margin-right: 0"
              />
            </div>
            <div
              v-for="(item, index) in rank_y"
              :key="index"
              @click="rangelink(item.m_id)"
            >
              <div v-if="index == 0" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/first.png"
                  alt=""
                />
              </div>
              <div v-else-if="index == 1" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/second.png"
                  alt=""
                />
              </div>
              <div v-else-if="index == 2" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/third.png"
                  alt=""
                />
              </div>
              <div v-else class="medal">
                <p>{{ index + 1 }}</p>
              </div>
              <div style="display: flex; align-items: center">
                <!-- <img :src="item.img" class="ranktx" alt="" /> -->
                <p>{{ item.name }}</p>
              </div>
              <p class="num">{{ item.hours }}h</p>
            </div>
          </div>
          <!-- <span></span> -->
          <div class="rankleft">
            <div
              class="colortop-yellow"
              style="border-radius: 8px 8px 0 0"
              @click="rank('rank_y_org')"
            >
              <img src="static/img/center01.png" class="medal" alt="" />
              <p class="font-weight font-333">组织排名</p>
              <van-icon
                name="arrow"
                size="16"
                style="margin-left: auto; margin-right: 0"
              />
            </div>
            <div
              v-for="(item, indexright) in rank_y_org"
              :key="indexright"
              @click="rangelink(item.m_id)"
            >
              <div v-if="indexright == 0" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/first.png"
                  alt=""
                />
              </div>
              <div v-else-if="indexright == 1" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/second.png"
                  alt=""
                />
              </div>
              <div v-else-if="indexright == 2" class="medal">
                <img
                  src="//pic-cdn.bigdatajy.com/wenming/static/img/third.png"
                  alt=""
                />
              </div>
              <div v-else class="medal">
                <p>{{ indexright + 1 }}</p>
              </div>
              <div style="display: flex; align-items: center">
                <!-- <img :src="item.img" class="ranktx" alt="" /> -->
                <p>{{ item.name }}</p>
              </div>
              <p class="num">{{ item.hours }}h</p>
            </div>
          </div>
        </div>
        <!-- <div class="rankbt">
          <div @click="rank('rank_y')">查看更多</div>
          <div @click="rank('rank_y_org')">查看更多</div>
        </div> -->
      </div>
    </div>
    <div class="center" style="padding: 0">
      <div
        class="flex colortop-yellow"
        style="padding: 10px; border-radius: 10px 10px 0 0"
      >
        <img
          src="static/img/center03.png"
          style="margin: 0; width: 20px; height: 20px; margin-right: 5px"
          alt=""
        />
        <p style="margin-right: auto" class="font-weight font-333">我的排名</p>
      </div>
      <div class="flex font-14" style="padding: 10px">
        <p>江阴市排名</p>
        <p>{{ ranknum.my_rank_year_all }}</p>
      </div>
      <div class="flex font-14" style="padding: 10px">
        <p>组织排名</p>
        <p>{{ ranknum.my_rank_month_org }}</p>
      </div>
    </div>
    <div style="padding-bottom: 65px"></div>
    <!-- 底部 -->
    <div class="footer">
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon01.png"
          class="icon"
          alt=""
          @click="urlchange('/')"
        />
        <p>首页</p>
      </div>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon02.png"
          class="icon"
          alt=""
          @click="urlchange('/cfshow')"
        />
        <p>澄风show</p>
      </div>
      <van-popover
        v-model="showPopover"
        trigger="click"
        :actions="actions"
        @select="onSelect"
        placement="top"
      >
        <template #reference>
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/icon05.png"
            style="width: 45px; height: 35px"
            alt=""
          />
        </template>
      </van-popover>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon03.png"
          class="icon"
          alt=""
          @click="urlchange('/eventcenterdetail')"
        />
        <p>活动中心</p>
      </div>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icona04.png"
          class="icon"
          alt=""
        />
        <p style="color: #1646c0">我的家园</p>
      </div>
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  name: "center",
  data() {
    return {
      org: "",
      totaljf: "",
      obj: {},
      badge: "",
      level: "志愿者",
      tab: 0,
      leftranklist: [],
      rightranklist: [],
      score: {},
      todayscore: "",
      rank_m: [],
      rank_m_org: [],
      rank_y: [],
      rank_y_org: [],
      ranknum: {},
      showPopover: false,
      actions: [
        { text: "发布报告", icon: "notes-o", className: "0" },
        { text: "发布心愿", icon: "exchange", className: "1" },
        { text: "我的收藏", icon: "like-o", className: "2" },
      ],
    };
  },
  created() {
    this.$axios({
      method: "post",
      url: "/api/home/index",
      data: this.qs.stringify({
        token: sessionStorage.getItem("wmtoken"),
      }),
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        this.ranknum = res.data.data;
        this.obj = res.data.data.member;
        this.totaljf = res.data.data.member_total_score;
        if (res.data.data.zhannei > 0) {
          this.badge = true;
        } else {
          this.badge = false;
        }
        if (!res.data.data.member.id) {
          this.$router.push("/register");
        }
        if (res.data.data.member.hours >= 100) {
          this.level = "一星志愿者";
        } else if (res.data.data.member.hours >= 300) {
          this.level = "二星志愿者";
        } else if (res.data.data.member.hours >= 600) {
          this.level = "三星志愿者";
        } else if (res.data.data.member.hours >= 1000) {
          this.level = "四星志愿者";
        } else if (res.data.data.member.hours >= 1500) {
          this.level = "五星志愿者";
        }
        sessionStorage.setItem("memberid", res.data.data.member.id);
        //console.log(this.obj);
        if (this.obj.img == "") {
          this.obj.img = "//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png";
          this.$forceUpdate();
        }
        if (!res.data.data.org_list[res.data.data.member.default_orgid]) {
          this.org = Object.values(res.data.data.org_list)[0].name;
        } else {
          this.org =
            res.data.data.org_list[res.data.data.member.default_orgid].name;
        }
        //console.log(this.org);
        //二期
        this.score = res.data.data.score;
        this.todayscore = res.data.data.today_score;
        //积分 月总
        this.rank_m = res.data.data.rank_month_all;
        this.rank_m_org = res.data.data.rank_month_org;
        this.$forceUpdate();
      } else {
        this.$toast(res.data.msg);
      }
    });
  },
  methods: {
    download() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) {
        location.href = "https://www.jywmsj.cn/h5/czsc.pdf";
      } else if (isiOS) {
        Dialog.alert({
          title: "请复制链接至浏览器下载",
          message: "https://www.jywmsj.cn/h5/czsc.pdf",
          confirmButtonText: "复制",
        }).then(() => {
          this.copy("https://www.jywmsj.cn/h5/czsc.pdf");
        });
      }
    },
    copy(value) {
      this.$copyText(value).then(
        (res) => {
          this.$toast("成功复制到粘贴板");
        },
        (err) => {
          this.$toast("复制失败");
        }
      );
    },
    rangelink(id) {
      this.$router.push({
        name: "homepage",
        query: {
          id,
          id,
        },
      });
    },
    onSelect(action) {
      console.log(action);
      if (action.className == 0) {
        this.$router.push("/mywishlist");
      }
      if (action.className == 1) {
        this.$router.push("/applywish");
      }
      if (action.className == 2) {
        this.$router.push("/myfav");
      }
    },
    urlchange(url) {
      this.$router.push(url);
    },
    logjf() {
      this.$axios({
        method: "post",
        url: "/api/home/login_score",
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("领取成功");
          this.score.login.num += 1;
          this.obj.socre += 1;
          this.todayscore += 1;
          this.$forceUpdate();
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    rank(type) {
      this.$router.push({
        name: "jfrank",
        query: {
          type: type,
        },
      });
    },
  },
};
</script>
<style scoped>
.van-icon {
  font-size: 25px;
  margin: 0 10px;
}
.container {
  background: #f5f6f7;
  min-height: 100vh;
}
.flex {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  width: 100%;
}
.flex img {
  height: 24px;
  width: auto;
  margin-left: 10px;
}
.top {
  padding: 10px;
  height: 80px;
}
.center {
  position: relative;
  padding: 10px;
  background: white;
  border-radius: 10px;
  margin: 10px;
}
.centerflex {
  display: flex;
  position: relative;
}
.tx {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: block;
  object-fit: cover;
  position: absolute;
  top: -20px;
  left: 20px;
  border: 5px solid white;
}
.centerflex > div {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.username {
  font-size: 20px;
  font-weight: bold;
  overflow-wrap: anywhere;
  margin-left: 90px;
}
.bt {
  border-radius: 20px;
  text-align: center;
  padding: 4px 8px;
  color: #1646c0;
  background: #e8ecf9;
  font-size: 14px;
  line-height: 14px;
  height: 14px;
}
.center .bt {
  white-space: nowrap;
}
.flexdiv {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.center .flex {
  display: flex;
  justify-content: space-between;
  text-align: center;
  width: auto;
  flex-direction: row;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  font-size: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  color: #434343;
  background: white;
}
/* .footer p {
  font-size: 0.289855rem;
} */
.footer div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 20%;
}
.icon {
  width: 20px;
  height: 20px;
}
.block {
  padding: 2px 10px;
  margin: 10px 0;
}
.blockflex {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
.block .color {
  width: 5px;
  height: 20px;
  background: #cab586;
  margin-right: 10px;
  display: inline-block;
  vertical-align: bottom;
}
.block span {
  line-height: 20px;
  height: 20px;
  display: inline-block;
}
.block .bt {
  border: 1px solid #a1a1a1;
  padding: 2px 10px;
}
.tabs {
  width: 100%;
  margin: 0 auto;
  color: #303133;
  display: flex;
  justify-content: space-between;
  height: 36px;
  font-size: 14px;
  margin-top: 10px;
}
.tabs > div {
  width: 100%;
}
.tabs p {
  text-align: center;
  line-height: 36px;
  width: 100%;
  color: #333333;
}
.tabhr {
  width: 4em;
  margin: auto;
  height: 6px;
  border-radius: 3px;
  background: linear-gradient(90deg, #1646c0 0%, rgba(255, 255, 255, 0) 100%);
}
.active {
  color: black !important;
  font-weight: bold;
}
.tabcontainer {
  padding: 10px 0;
  margin-bottom: 10px;
}
.rank {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.rank > div {
  width: 100%;
}
.rank span {
  display: inline-block;
  height: 30px;
  width: 2px;
  background: #a1a1a1;
}
.rank p {
  text-align: center;
  width: 100%;
  margin: 5px;
}
.medal {
  width: 20px;
  text-align: center;
  margin-right: 5px;
}
.medal img {
  height: 20px;
  width: 20px;
  display: block;
  object-fit: contain;
}
.ranktx {
  width: 10vw;
  height: 10vw;
  display: block;
  border-radius: 50%;
  object-fit: cover;
}
.num {
  color: orange;
  margin-left: auto;
}
.rankmain {
  display: flex;
}
.rankmain > div {
  width: 100%;
  margin: 0 5px;
  background: white;
  border-radius: 8px;
}
.rankmain span {
  height: 518px;
  width: 2px;
  background: #a1a1a1;
  display: inline-block;
}
.rankleft > div {
  display: flex;
  align-items: center;
  padding: 10px 5px;
}
.rankbt {
  display: flex;
  justify-content: space-around;
}
.rankbt div {
  border: 1px solid #a1a1a1;
  padding: 2px 5px;
  width: 30%;
  margin: 10px auto;
  text-align: center;
}
.font-12 {
  font-size: 12px;
}
.font-14 {
  font-size: 14px;
}
.font-weight {
  font-weight: bold;
}
.font-333 {
  color: #333333;
}
.colortop-yellow {
  background: linear-gradient(
    to bottom,
    rgba(255, 194, 59, 0.21) 0%,
    white 100%
  ) !important;
}
.colortop-yellow2 {
  background: linear-gradient(
    to bottom,
    rgba(255, 194, 59, 0.21) 0%,
    white 50%
  ) !important;
}
.colortop-blue {
  background: linear-gradient(
    180deg,
    rgba(51, 154, 253, 0.2) 0%,
    rgba(255, 255, 255, 0) 100%
  ) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/center.vue